import client from '../client';
import { Invitation } from '../media';

export const show = (id: string) =>
  client.get<Invitation>(`/invitations/${id}`).then(resp => resp.data);
